// src/features/games/components/GameSupplier.tsx

import { Button, Header3, Header4 } from "../../../components/ui";
import { BlobContainerConsts } from "../../../models/constants/blobContainerConsts";
import { GameSupplierList } from "../models/responses/supplierListResponse";

interface GameSupplierProps {
  suppliers: GameSupplierList[];
  selectedSupplier: string | null;
  onSelect: (supplierName: string | null) => void;
}

export function GameSupplier({
  suppliers,
  selectedSupplier,
  onSelect,
}: GameSupplierProps) {
  return (
    <div>
      {/* Header row */}
      <div className="flex justify-between items-center mb-3">
        <Header4>Provider Games</Header4>
        {selectedSupplier && (
          <Button
            onClick={() => onSelect(null)}
            className="text-white text-xs underline"
          >
            Clear Filter
          </Button>
        )}
      </div>

      {/* 4-column grid with small cards */}
      <div
        className="max-h-[60vh] overflow-y-auto scrollbar-none"
        style={{
          scrollbarWidth: "none" /* Firefox */,
          msOverflowStyle: "none" /* IE/Edge */,
        }}
      >
        <div className="grid grid-cols-4 gap-2">
          {suppliers.map((supplier) => (
            <Button
              key={supplier.gameSubProviderCode}
              onClick={() => onSelect(supplier.name)}
              className="flex flex-col items-center gap-1"
            >
              <div
                className={`w-16 h-16 rounded-lg overflow-hidden border-2 flex items-center justify-center bg-gray-900 ${
                  selectedSupplier === supplier.name
                    ? "border-white"
                    : "border-transparent"
                }`}
              >
                <img
                  src={`${process.env.REACT_APP_BLOB_IMAGE_URL}${BlobContainerConsts.GameSupplier}/${supplier.webImagePath}`}
                  alt={supplier.name}
                  className="w-full h-full object-contain p-1"
                />
              </div>
              <span className="text-white text-[10px] text-center leading-tight line-clamp-2 w-16">
                {supplier.name}
              </span>
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
}
